import React from 'react';
import Navbar from '../layout/Navbar';
import Hero from '../sections/Hero';
import Features from '../sections/Features';
import VoiceModels from '../sections/VoiceModels';
import Pricing from '../sections/Pricing';
import BlogPreview from '../sections/BlogPreview';
import FAQ from '../sections/FAQ';
import Footer from '../layout/Footer';
import SEO from '../common/SEO';
import PerformanceOptimizer from '../common/PerformanceOptimizer';
import FAQSchema from '../common/FAQSchema';

const Landing = () => {
  // Structured data for the homepage (Organization and WebSite)
  const structuredData = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Organization',
        '@id': 'https://qualityaivoice.com/#organization',
        'name': 'QualityAIvoice',
        'url': 'https://qualityaivoice.com/',
        'logo': {
          '@type': 'ImageObject',
          'url': 'https://qualityaivoice.com/images/logo.png'
        },
        'sameAs': [
          'https://twitter.com/qualityaivoice',
          'https://www.facebook.com/qualityaivoice',
          'https://www.linkedin.com/company/qualityaivoice'
        ]
      },
      {
        '@type': 'WebSite',
        '@id': 'https://qualityaivoice.com/#website',
        'url': 'https://qualityaivoice.com/',
        'name': 'QualityAIvoice - Best Text to Speech Software 2026',
        'description': 'Best text to speech software 2026. Free AI voice generator with 500+ natural-sounding voices across 50+ languages for content creators, educators, and businesses.',
        'publisher': {
          '@id': 'https://qualityaivoice.com/#organization'
        }
      }
    ]
  };

  // FAQ data for structured data - optimized to match high-impression search queries
  const faqData = [
    {
      question: "What is the best text to speech software in 2026?",
      answer: "QualityAIvoice is rated as one of the best text to speech software solutions in 2026, offering 500+ AI voices, 50+ languages, real-time processing, voice customization, and a free tier with 10,000 characters. Our advanced neural network technology produces natural-sounding speech that's virtually indistinguishable from human voices."
    },
    {
      question: "Is QualityAIvoice a free AI voice generator?",
      answer: "Yes! QualityAIvoice offers a free plan with 10,000 characters, standard TTS voices, and MP3 downloads — no credit card required. Our premium plans start at just $5 for 100,000 characters with high-quality neural voices and commercial usage rights."
    },
    {
      question: "What are the best text to speech apps in 2026?",
      answer: "The best text to speech apps in 2026 include QualityAIvoice, which stands out with 500+ AI voices, 50+ language support, real-time processing, and an intuitive web-based interface. It's perfect for content creators, educators, podcasters, and businesses looking for natural-sounding AI voice generation."
    },
    {
      question: "How has text to speech technology evolved (TTS evolution)?",
      answer: "Text to speech technology has evolved dramatically from robotic-sounding voices to incredibly natural AI-generated speech. Modern TTS uses neural networks and deep learning to understand context, emotion, and natural speech patterns. QualityAIvoice represents the cutting edge of this TTS evolution with state-of-the-art voice synthesis technology."
    },
    {
      question: "What languages does QualityAIvoice support?",
      answer: "QualityAIvoice supports over 50 languages including English, Spanish, French, German, Italian, Portuguese, Japanese, Korean, Chinese, Hindi, Arabic, and many more. Each language has multiple voice options with different regional accents and speaking styles."
    },
    {
      question: "Can I use QualityAIvoice for commercial projects?",
      answer: "Yes, our Standard and Premium plans include commercial usage rights for all generated audio content. You can use the AI-generated voices for YouTube videos, podcasts, audiobooks, e-learning courses, marketing campaigns, and business applications."
    }
  ];

  return (
    <div className="min-h-screen">
      <SEO 
        title="Best Text to Speech Software 2026 | Free AI Voice Generator Online"
        description="Best text to speech software 2026 - Generate natural-sounding AI voices free online. 500+ realistic TTS voices, 50+ languages. Top-rated AI voice generator for content creators, educators & businesses."
        keywords="best text to speech software 2026, best text to speech apps 2026, free text to speech online, AI voice generator, text to speech AI, best tts software, top text to speech tools 2026, best ai text to speech services 2026, tts evolution, natural sounding text to speech, free ai voice generator"
        canonicalUrl="https://qualityaivoice.com/"
        structuredData={structuredData}
      />
      
      <PerformanceOptimizer 
        preloadImages={[
          'https://qualityaivoice.com/images/og-image.jpg',
          'https://qualityaivoice.com/images/hero-bg.jpg'
        ]}
        dnsPrefetch={[
          'https://fonts.googleapis.com',
          'https://fonts.gstatic.com'
        ]}
      />
      
      <FAQSchema faqs={faqData} />
      
      <Navbar />
      <Hero />
      <Features />
      <VoiceModels />
      <Pricing />
      <BlogPreview />
      <FAQ />
      <Footer />
    </div>
  );
};

export default Landing;